import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AppUpdateNotificationComponent } from "./app-update-notification.component";

@NgModule({
  declarations: [AppUpdateNotificationComponent],
  imports: [CommonModule],
  exports: [AppUpdateNotificationComponent],
})
export class AppUpdateNotificationModule {}
